import { render, staticRenderFns } from "./VehicleTypeList.vue?vue&type=template&id=157d4e0c&scoped=true"
import script from "./VehicleTypeList.vue?vue&type=script&lang=js"
export * from "./VehicleTypeList.vue?vue&type=script&lang=js"
import style0 from "./VehicleTypeList.vue?vue&type=style&index=0&id=157d4e0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157d4e0c",
  null
  
)

export default component.exports